export default "__VITE_ASSET__CnFrE3LV__"